<ng-container *ngIf="isAdminUser && !(deactivateSupplyWishDate | async)">
  <p *ngIf="commissioningOrderDto && commissioningOrderDto.state == pendingAppointment">
    Bitte legen Sie einen Durchführungstermin fest um fortzufahren.
  </p>
  <div fxLayout="row" *ngIf="isAdminUser" fxFlexAlign="stretch" style="margin-top: 1rem">
    <div fxFlex="100">
      <div fxLayout="row" fxFlexAlign="stretch">
        <p>
          <strong>Wunschtermin Installateur:</strong>
          {{ commissioningOrderDto.supplyAppointmentWishDate | date : 'shortDate' }}
          <span *ngIf="commissioningOrderDto.supplyAppointmentWishPartday">
            ({{ commissioningOrderDto.supplyAppointmentWishPartday | supplyAppointmentPartDay }})
          </span>
        </p>
      </div>
      <div fxLayout="row" fxFlexAlign="stretch">
        <p class="mat-error" *ngIf="!inputForm.get('date').value || !inputForm.get('time').value">
          <strong>Bitte legen Sie den Durchführungstermin fest.</strong>
        </p>
        <p *ngIf="inputForm.get('date').value && inputForm.get('time').value">
          <strong>Durchführungstermin am:</strong>
          {{ inputForm.get('date').value | date : 'shortDate' }} um: {{ inputForm.get('time').value }} Uhr.
        </p>
      </div>
    </div>
  </div>
  <form [formGroup]="inputForm" *ngIf="inputForm" style="margin-top: 1rem">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px" style="margin-bottom: 1em">
      <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
        <button
          mat-raised-button
          [disabled]="!canUpdate"
          color="primary"
          id="modal-cancel-button"
          (click)="dialogAppoinmentAgree()">
          <span *ngIf="!inputForm.get('date').value">Durchführungstermin festlegen</span>
          <span *ngIf="inputForm.get('date').value">Durchführungstermin ändern</span>
        </button>
      </div>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="!isAdminUser">
  <ng-container *ngIf="!(deactivateSupplyWishDate | async); else appointmentDisabled">
    <mat-card appearance="outlined" style="margin-bottom: 2em; background-color: yellow">
      <mat-card-content>
        Bitte beachten Sie, dass es sich bei dem angegebenen Termin um einen Wunschtermin handelt. Einen von
        uns bestätigten Durchführungstermin erhalten Sie nachdem wir den Antrag geprüft haben.
        <p *ngIf="commissioningOrderDto?.area?.name != 'DISTRICTHEAT'">
          Sofern Sie eine genehmigungspflichtige Anlage angefragt haben, hängt die Terminvereinbarung von der
          Freigabe der Anlage ab.
        </p>
      </mat-card-content>
    </mat-card>
    <form [formGroup]="inputForm" *ngIf="inputForm">
      <div
        class="wrapper"
        *ngIf="
          !commissioningOrderDto ||
          (!requestedApproved.includes(commissioningOrderDto.state) &&
            commissioningOrderDto.state != statusApproved)
        ">
        <div class="col" fxFlex="100">
          <div
            *ngIf="
              !inputForm.get('supplyAppointmentWishDate').value ||
              !inputForm.get('supplyAppointmentWishPartday').value
            ">
            <p style="font-weight: bold">Wunschtermin</p>
            <p style="font-weight: bold">
              Termine verfügbar ab: {{ firstDateAvailable | date : 'shortDate' }}
            </p>
            <p>
              Bitte geben Sie uns einen Wunschtermin mit. Wir werden versuchen diesen möglich zu machen. Sie
              erhalten dann den endgültigen Termin von uns via Mail.
            </p>
          </div>
          <div *ngIf="inputForm.get('supplyAppointmentWishDate').value" style="margin-bottom: 1rem">
            <p>
              <strong
                *ngIf="
                  inputForm.get('supplyAppointmentWishDate').value &&
                  inputForm.get('supplyAppointmentWishPartday').value
                ">
                Wunschtermin am:
                {{ inputForm.get('supplyAppointmentWishDate').value | date : 'shortDate' }}
                ({{ inputForm.get('supplyAppointmentWishPartday').value | supplyAppointmentPartDay }})
              </strong>
            </p>
          </div>
          <div
            fxLayout="row"
            fxFlexAlign="stretch"
            *ngIf="!commissioningOrderDto || !requestedApproved.includes(commissioningOrderDto.state)">
            <mat-form-field appearance="outline" fxFlex="35" name="date" style="margin-right: 1rem">
              <mat-label>Datum</mat-label>
              <input
                matInput
                formControlName="supplyAppointmentWishDate"
                [matDatepicker]="supplyAppointment"
                [matDatepickerFilter]="weekendsDatesFilter"
                placeholder="Besichtigungstermin vereinbaren:" />
              <mat-datepicker-toggle matSuffix [for]="supplyAppointment"></mat-datepicker-toggle>
              <mat-datepicker #supplyAppointment></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Tageszeit</mat-label>
              <mat-select formControlName="supplyAppointmentWishPartday">
                <mat-option *ngFor="let ele of listPartDays" [value]="ele.value" [disabled]="!ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="wrapper"
        *ngIf="commissioningOrderDto && requestedApproved.includes(commissioningOrderDto.state)">
        <div class="col" fxFlex="100">
          <p>
            <strong>Wunschtermin wurde am</strong>
            {{ commissioningOrderDto.supplyAppointmentWishDate | date : 'shortDate' }}
            ({{ commissioningOrderDto.supplyAppointmentWishPartday | supplyAppointmentPartDay }})
            <strong>angefordert</strong>
          </p>
        </div>
      </div>
      <div class="wrapper" *ngIf="commissioningOrderDto && commissioningOrderDto.state == statusApproved">
        <div class="col" fxFlex="100">
          <div fxLayout="row" fxFlexAlign="stretch">
            <strong *ngIf="inputForm.get('supplyAppointmentWishDate').value">
              Durchführungstermin:
              {{ inputForm.get('date').value | date : 'shortDate' }} um:
              {{ inputForm.get('time').value }} Uhr.
            </strong>
          </div>
          <p>
            Wenn Sie den Termin nicht wahrnehmen können, nehmen Sie bitte Kontakt zur unserer Disposition auf.
          </p>
        </div>
      </div>
    </form>

    <div class="wrapper" *ngIf="commissioningOrderDto && commissioningOrderDto.state != statusApproved">
      <div class="col" fxFlex="100">
        <div *ngIf="!selectedWishDateOK">
          <mat-error style="font-weight: bold">
            Bitte wählen Sie einen Termin nach dem
            {{ firstDateAvailable | date : 'shortDate' }}
          </mat-error>
        </div>
        <div *ngIf="!selectedWishPartDateOK">
          <mat-error style="font-weight: bold">Wunschtermin Tageszeit ist erforderlich</mat-error>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #appointmentDisabled>
    <ng-container
      *ngIf="areaType && (getHintAdaptionName(areaType) | uiAdaptionVisible$ | async); else defaultHint">
      <app-hint-card [outlined]="true" [type]="'warning'">
        <div [innerHTML]="getHintAdaptionName(areaType) | uiAdaptionValue | safeHtmlPipe"></div>
      </app-hint-card>
    </ng-container>
    <ng-template #defaultHint>
      <app-hint-card [outlined]="true" [type]="'warning'">
        Der Durchführungstermin wird vom Netzbetreiber festgelegt.
      </app-hint-card>
    </ng-template>
  </ng-template>
</ng-container>
